import TaskListSC from './TaskListSC';

export default TaskListSC;
